import { render, staticRenderFns } from "./HtmlCodeMenu.vue?vue&type=template&id=4962fdc2&"
import script from "./HtmlCodeMenu.vue?vue&type=script&lang=js&"
export * from "./HtmlCodeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports